export class ImagePurchaseValidationModel {
    public subscriptionPlanId: number;
    public canPurchaseImage: boolean;
    public availableImageCount: number;
    public totalAmount: number;
    public paybleAmount: number;
}
